/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Account_SubInputs */

const en_funnel_account_sub = /** @type {(inputs: Funnel_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your free trial starts as soon as your account is ready. You won't be charged today.`)
};

const es_funnel_account_sub = /** @type {(inputs: Funnel_Account_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu prueba gratuita empieza en cuanto tu cuenta esté lista. Hoy no se te cobrará nada.`)
};

/**
* | output |
* | --- |
* | "Your free trial starts as soon as your account is ready. You won't be charged today." |
*
* @param {Funnel_Account_SubInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_account_sub = /** @type {((inputs?: Funnel_Account_SubInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Account_SubInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_account_sub(inputs)
	return en_funnel_account_sub(inputs)
});